import React, { useState, useEffect } from "react";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Trash2, ExternalLink } from "lucide-react";

const toAbsoluteImageUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) return path;

  const base = (process.env.REACT_APP_UPLOAD_URL || process.env.REACT_APP_BASE_URL || "").replace(/\/$/, "");
  const cleanPath = String(path).replace(/^\/+/, "");
  return base ? `${base}/${cleanPath}` : path;
};

export default function ReferenceList() {
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRefs = async () => {
    try {
      const res = await api.get("/reference");
      const mapped = (res.data || []).map((ref) => ({
        ...ref,
        imageUrl: toAbsoluteImageUrl(
          ref.referenceLogo || ref.logoPath || ref.imagePath || ref.referenceLogoPath
        ),
      }));
      setReferences(mapped);
    } catch {
      toast.error("Referanslar yüklenemedi");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRefs();
  }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Bu referansı silmek istediğinize emin misiniz?"))
      return;
    api
      .delete(`/reference/${id}`)
      .then(() => {
        toast.success("Referans silindi");
        fetchRefs();
      })
      .catch(() => toast.error("Silme başarısız"));
  };

  if (loading)
    return (
      <div className="page-loading">
        <div className="loading-spinner" />
        <p>Yükleniyor...</p>
      </div>
    );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Referanslar</h2>
          <p className="page-subtitle">{references.length} referans</p>
        </div>
      </div>

      <div className="reference-grid">
        {references.map((ref) => (
          <div key={ref.referenceId} className="reference-card">
            <div className="reference-logo">
              {ref.imageUrl ? (
                <img
                  src={ref.imageUrl}
                  alt={ref.referenceName}
                />
              ) : (
                <div className="ref-placeholder">
                  {ref.referenceName?.charAt(0)}
                </div>
              )}
            </div>
            <div className="reference-info">
              <h4>{ref.referenceName}</h4>
              {ref.referenceUrl && (
                <a
                  href={ref.referenceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ref-link"
                >
                  <ExternalLink size={14} /> Website
                </a>
              )}
            </div>
            <button
              onClick={() => handleDelete(ref.referenceId)}
              className="btn-icon delete small"
            >
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>

      {references.length === 0 && (
        <div className="empty-state">
          <p>Henüz referans eklenmemiş</p>
        </div>
      )}
    </div>
  );
}
